export const PASSWORD_POLICY_MESSAGE =
  "Requieres al menos un carácter especial, una letra mayúscula y un número.";

export const PASSWORD_UPDATED_MESSAGE =
  "La contraseña ha sido actualizada con éxito.";

export const isPasswordPolicyValid = (password: string | undefined): boolean => {
  if (!password) {
    return false;
  }

  if (password.length < 8 || password.length > 12) {
    return false;
  }

  const hasUpper = /[A-Z]/.test(password);
  const hasLower = /[a-z]/.test(password);
  const hasDigit = /\d/.test(password);
  const hasSpecial = /[^A-Za-z0-9]/.test(password);

  return hasUpper && hasLower && hasDigit && hasSpecial;
};
